import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-tipo-contrato',
  templateUrl: './add-tipo-contrato.component.html',
  styleUrls: ['./add-tipo-contrato.component.css']
})
export class AddTipoContratoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
